$(document).on('turbo:load turbo:render fieldsAdded', () => {

    $(".expandable-form").on("show.bs.collapse", (e)=>{
        let $target  = $(e.currentTarget);
        if (!$(e.target).hasClass("datepicker")) {
            $target.closest(".accordion-fieldset-container").find(".expandable-form").each((index, item) => {
                let $item = $(item);
                $item.removeClass("show");
            })
        }
        })



});